(() => {
  const root = document.getElementById('bg-launch');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const q = s => root.querySelector(s);
  const qa = s => [...root.querySelectorAll(s)];
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:root.dataset.currency || 'USD',minimumFractionDigits:value % 100 ? 2 : 0}).format(value / 100);
  const dialog = q('#bag-dialog');
  let busy = false;
  let cart = null;
  let opener = null;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  async function request(url, body) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url, {method:body ? 'POST' : 'GET',credentials:'same-origin',cache:'no-store',signal:controller.signal,headers:{'Accept':'application/json',...(body ? {'Content-Type':'application/json'} : {})},...(body ? {body:JSON.stringify(body)} : {})});
      const data = await response.json();
      if (!response.ok) {
        const error = new Error(data.description || data.message || 'Your bag could not be updated.');
        // A server failure can leave a write outcome unknown; never retry it automatically.
        error.confirmed = response.status >= 400 && response.status < 500;
        throw error;
      }
      return data;
    } finally {clearTimeout(timer);}
  }
  function counts(count) {
    q('#bag-count').textContent = count;
    q('#sticky-bag-count').textContent = count;
    q('#open-bag-sticky').hidden = count === 0;
    q('.shop-nav').classList.toggle('has-bag', count > 0);
    qa('#open-bag,#open-bag-sticky').forEach(b => b.setAttribute('aria-label', `Open bag, ${count} ${count === 1 ? 'item' : 'items'}`));
  }
  function renderCart() {
    counts(cart.item_count);
    q('#bag-items').innerHTML = cart.items.length ? cart.items.map(item => {
      const properties = item.properties || {};
      const pre = properties['Purchase Type'] === 'Pre-Order' || /pre[- ]order/i.test(item.product_title);
      const date = properties['Estimated Ship Date'] || (pre ? 'Preorder · see product for estimated shipping' : '');
      return `<li class="bag-item">${item.image ? `<img src="${escape(item.image)}&width=160" alt="" width="72" height="72">` : ''}<div><p>${escape(item.product_title)}</p><small>${escape(item.variant_title)} · Qty ${item.quantity}</small>${date ? `<small>${escape(date)}</small>` : ''}<button type="button" class="remove" data-remove="${escape(item.key)}" aria-label="Remove ${escape(item.product_title)} ${escape(item.variant_title)}">Remove</button></div><span class="bag-item-price">${money(item.final_line_price)}</span></li>`;
    }).join('') : '<li class="empty">Your bag is waiting for a little Bubble Gum Pink.</li>';
    q('#bag-total').innerHTML = cart.items.length ? `<span>Subtotal</span><span>${money(cart.total_price)}</span>` : '';
    const preorder = cart.items.some(item => item.properties?.['Purchase Type'] === 'Pre-Order' || /pre[- ]order/i.test(item.product_title));
    q('#bag-shipping').textContent = preorder ? 'If your order includes preorder pieces, all items ship together on the preorder schedule. Place separate orders to receive in-stock pieces sooner.' : '';
    q('#bag-checkout').disabled = !cart.item_count || busy;
  }
  async function refreshCart() {
    cart = await request(root.dataset.cartUrl + '.js');
    renderCart();
  }
  function setBusy(value) {
    busy = value;
    qa('.product-form .add').forEach(button => { button.disabled = value || !button.form.querySelector('input[name="id"]:not(:disabled)'); });
    qa('[data-remove]').forEach(button => button.disabled = value);
    q('#bag-checkout').disabled = value || !cart?.item_count;
  }
  function closeBag() {
    dialog.close();
    opener?.focus();
  }
  async function openBag(event) {
    event?.preventDefault();
    opener = event?.currentTarget || document.activeElement;
    q('#bag-error').textContent = '';
    q('#bag-items').innerHTML = '<li class="empty">Loading your bag…</li>';
    q('#bag-checkout').disabled = true;
    if (!dialog.open) dialog.showModal();
    try { await refreshCart(); }
    catch { q('#bag-error').textContent = 'Your bag could not load. Use “View or edit your full bag” below to continue.'; }
  }
  qa('#open-bag,#open-bag-sticky').forEach(button => button.addEventListener('click', openBag));
  qa('#close-bag,#continue-shopping').forEach(button => button.addEventListener('click', closeBag));
  dialog.addEventListener('cancel', event => { event.preventDefault(); closeBag(); });
  root.addEventListener('change', event => {
    const option = event.target.closest('.size-option');
    if (!option) return;
    const form = option.form;
    const card = form.closest('.product-card');
    const pre = option.dataset.state === 'preorder';
    const status = card.querySelector('.availability');
    status.classList.remove('needs-size');
    card.querySelector('.sizes').classList.remove('needs-size');
    status.textContent = `Size ${option.dataset.size} · ${pre ? 'Preorder' + (option.dataset.shipDate ? ' · est. ship ' + option.dataset.shipDate : ' · see product for timing') : 'In stock'}.`;
    card.querySelector('[data-card-price]').textContent = money(Number(option.dataset.price));
    const compare = card.querySelector('[data-card-compare]');
    compare.hidden = Number(option.dataset.compare) <= Number(option.dataset.price);
    compare.textContent = money(Number(option.dataset.compare));
    card.querySelector('.add').textContent = `${pre ? 'Preorder' : 'Add'} ${option.dataset.size} · ${money(Number(option.dataset.price))}`;
    form.querySelectorAll('[data-line-property]').forEach(input => input.remove());
    if (pre) {
      const properties = {'Purchase Type':'Pre-Order','Estimated Ship Date':option.dataset.cartDate,'_Parent Product Handle':option.dataset.parentHandle,'_Parent Variant ID':option.dataset.parentId,'Color':'Bubble Gum','Size':option.dataset.optionSize || option.dataset.size};
      Object.entries(properties).forEach(([key,value]) => {if (key === 'Estimated Ship Date' && !value) return;const input = document.createElement('input');input.type='hidden';input.name=`properties[${key}]`;input.value=value;input.dataset.lineProperty='true';form.append(input);});
    }
  });
  qa('.product-form').forEach(form => {
    form.noValidate = true;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      const option = form.querySelector('input[name="id"]:checked');
      const card = form.closest('.product-card');
      const status = card.querySelector('.availability');
      if (!option || option.disabled) {
        status.textContent = 'Pick a size first.';
        status.classList.add('needs-size');
        card.querySelector('.sizes').classList.add('needs-size');
        form.querySelector('input[name="id"]:not(:disabled)')?.focus();
        return;
      }
      const properties = {};
      form.querySelectorAll('[data-line-property]').forEach(input => properties[input.name.slice(11,-1)] = input.value);
      const button = card.querySelector('.add');
      const label = button.textContent;
      setBusy(true);button.textContent = 'Adding…';
      let added = false;
      try {
        await request(root.dataset.cartAddUrl + '.js', {items:[{id:Number(option.value),quantity:1,properties}]});
        added = true;
        await refreshCart();
        opener = button;q('#bag-error').textContent='';if (!dialog.open) dialog.showModal();
      } catch (error) {
        if (added) {
          counts(Number(q('#bag-count').textContent) + 1);
          status.textContent = 'Added to your bag. Open Bag or view your full bag to continue.';
        } else if (error.confirmed) {
          status.textContent = error.message;
        } else {
          status.textContent = 'We could not confirm the update. Check your bag before trying again.';
          opener = button;q('#bag-error').textContent=status.textContent;if (!dialog.open) dialog.showModal();
          try { await refreshCart(); } catch { q('#bag-items').innerHTML='<li class="empty">Use “View or edit your full bag” to check your items.</li>'; }
        }
      } finally {setBusy(false);button.textContent=label;}
    });
  });
  q('#bag-items').addEventListener('click', async event => {
    const button = event.target.closest('[data-remove]');
    if (!button || busy) return;
    setBusy(true);q('#bag-error').textContent='';
    try {cart=await request(root.dataset.cartChangeUrl + '.js',{id:button.dataset.remove,quantity:0});renderCart();q('#close-bag').focus();}
    catch {q('#bag-error').textContent='We could not confirm that change. View your full bag before trying again.';try {await refreshCart();} catch {}}
    finally {setBusy(false);}
  });
  let navTick = false;
  function syncNav() {
    const active = q('#more-colors').getBoundingClientRect().top <= q('.shop-nav').offsetHeight + 80 ? 'more-colors' : 'bubble-gum';
    qa('.shop-nav a').forEach(a => {const current=a.getAttribute('href') === '#'+active;a.classList.toggle('active',current);if(current)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current');});
  }
  window.addEventListener('scroll', () => {if(!navTick){navTick=true;requestAnimationFrame(()=>{syncNav();navTick=false;});}}, {passive:true});
  window.addEventListener('resize',syncNav);
  window.addEventListener('pageshow', () => {refreshCart().catch(()=>{});});
  counts(Number(q('#bag-count').textContent));syncNav();
})();
